<template>
	<div class="update">
		<div class="edit-title">
			<!-- <h2 class="qjc-fts-20 qjc-c-dark qjc-ftw-500">{{id ? '文章详情' : '新增文章'}}</h2> -->
			<!-- <el-image class="back-icon" :src="require('@/assets/images/main_bio_back.png')" @click="handleBack"></el-image> -->
		</div>
		<el-form ref="form" class="edit-form" :model="form" label-width="80px">
			<el-form-item label="标题：">
				<el-input class="title-input" v-model="form.title"></el-input>
			</el-form-item>
			<!-- <el-form-item label="来源：">
				<el-input class="auth-input" v-model="form.source"></el-input>
			</el-form-item> -->
			<el-form-item label="内容：">
				<tinymce-editor ref="editor" :tinyvalue="form.content" v-model="editorValue" @tinymceinput="tinymceinput"></tinymce-editor>
			</el-form-item>
			<el-form-item label="排序：">
				<el-input class="auth-input" type="number" v-model="form.sort"></el-input>
			</el-form-item>
			<el-form-item label="状态：">
				<el-radio-group v-model="form.status">
					<el-radio label="1">显示</el-radio>
					<el-radio label="0">不显示</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item class="foot-submit">
				<el-button class="submit-btn" @click="onSubmit">提交</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	import { getFaqList } from '@/utils/axios.js';
	import tinymceEditor from "@/components/tinymceEditor";
	
	
	export default{
		name: 'scienceEdit',
		components:{
			tinymceEditor
		},
		data() {
			return {
				editorValue: '', // 文章内容
				file_url: '',  // 图片路径
				imgFile: {}, //图片文件 file
			}
		},
		props: [
			'close', 'id', 'form'
		],
		mounted() {
		},
		methods: {
			// 关闭弹窗
			handleBack() {
				this.close();
			},
			// 绑定文章内容
			tinymceinput(e) {
				this.form.content = e
			},
			// 提交操作
			onSubmit() {
				let actV = ''
				if(this.id) { //根据是否含有ID判断操作类型
					actV = 'update'
				} else {
					actV = 'add'
				}
				
				let form = this.form;
				if(form.title == '' || form.title == undefined || form.title == 'undefined'){
					this.$myAlert({
						type: 'fail',
						title: '请填写标题'
					});
					return
				}
				if(form.content == '' || form.content == undefined || form.content == 'undefined') {
					this.$myAlert({
						type: 'fail',
						title: '请编辑内容'
					});
					return
				}
				if(form.sort == '' || form.sort == undefined || form.sort == 'undefined') {
					this.$myAlert({
						type: 'fail',
						title: '请填写排序'
					});
					return
				}
				if(form.status == '' || form.status == undefined || form.status == 'undefined') {
					this.$myAlert({
						type: 'fail',
						title: '请选择文章状态'
					});
					return
				}
				form.act = actV
				
				getFaqList(form).then((res) => {
					if(res.code == 200){
						this.$myAlert({
							type: 'success',
							title: res.msg,
							callback: () => {
								this.close();
								if(actV == 'update') {
									this.$router.push('/mainScience')
								}
							}
						});
					}
				})
			},
			// 处理配图本地图片
			handleFileImg(e) {
				let file = e.target.files[0]
				this.imgFile = e.target.files[0]
				this.file_url = window.URL.createObjectURL(file)
				this.form.file_url = window.URL.createObjectURL(file)
			},
		},
	}
	
</script>

<style scoped> 
.img-box {
	width: 64px;
	height: 64px;
	z-index: 9;
}
.file-input-box {
	position: relative;
	width: 66px;
	height: 66px;
	border: 1px solid #D5D8DE;
	cursor: pointer;
}
.file-input {
	position: absolute;
	width: 64px;
	height: 64px;
	opacity: 0;
	z-index: 11;
}

.file-input-del {
	padding-left: 18px;
	line-height: 20px;
	margin-top: -10px;
}

.file-input-del span {
	cursor: pointer;
}
.back-icon {
	width: 20px;
	height: 20px;
	cursor: pointer;
	margin-left: 10px;
}

.edit-form >>> input::-webkit-outer-spin-button,
.edit-form >>> input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

.edit-form >>> input[type="number"] {
  -moz-appearance: textfield;
}

.edit-form >>> .el-upload {
	width: 100%;
	height: 100%;
	padding-top: 10px;
}
.edit-form >>> .tox .tox-menubar {
	background-color: #f3f4fc;
}
.edit-form >>> .tox .tox-mbtn {
	color: #333;
}
.edit-form >>> .tox .tox-tbtn {
	color: #333;
}
.edit-form >>> .tox .tox-tbtn svg {
	fill: #333;
}
.edit-form >>> .tox .tox-toolbar, .edit-form >>> .tox .tox-toolbar__overflow, .edit-form >>> .tox .tox-toolbar__primary {
	background-color: #f3f4fc;
	height: 40px;
	position: relative;
	border-bottom: 1px solid #aaa;
}
.edit-form >>> .tox .tox-tbtn--disabled, .edit-form >>>.tox .tox-tbtn--disabled:hover, .edit-form >>> .tox .tox-tbtn:disabled, .edit-form >>> .tox .tox-tbtn:disabled:hover {
	color: #333;
}
.edit-form >>> .tox .tox-statusbar {
	background-color: #f3f4fc;
	color: #333;
	border-color: #aaa;
}
.edit-form >>> .tox .tox-statusbar a,.edit-form >>>  .tox .tox-statusbar__path-item,.edit-form >>>  .tox .tox-statusbar__wordcount {
	color: #333;
}
.edit-form >>> .tox-tinymce {
	border-color: #aaa;
}
.edit-form >>> .tox .tox-menubar+.tox-toolbar,.edit-form >>>  .tox .tox-menubar+.tox-toolbar-overlord .tox-toolbar__primary {
	border-color: #aaa;
}
.edit-form >>> .tox .tox-sidebar {
	border-color: #aaa;
}
.edit-form >>> .tox:not([dir=rtl]) .tox-toolbar__group:not(:last-of-type) {
	border-color: #aaa;
}
</style>

<style lang="scss" scoped>
	.file-input-box {
		padding-bottom: 6px;
		
		&::after {
			position: absolute;
			top: -4px;
			content: '+';
			font-size: 40px;
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			height: 100%;
			cursor: pointer;
			z-index: 2;
		}
	}
	.edit-title {
		display: flex;
		align-items: center;
	}
	.edit-form {
		// margin-top: 0.32px;
		
		.title-input {
			width: 440px;
		}
		
		.auth-input {
			width: 240px;
		}
		
		.foot-submit {
			text-align: center;
		}
		.submit-btn {
			width: 200px;
			height: 48px;
			background: #6681FA;
			border-radius: 4px;
			font-size: 16px;
			font-family: PingFangSC-Semibold, PingFang SC;
			font-weight: 600;
			color: #FFFFFF;
			border: none;
			&::after {
				border: none;
				border-radius: 0;
			}
		}
		
		.el-button:active {
			background-color: #5B73DC;
		}
	}
	
	.upload-box {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 64px;
		height: 64px;
		border: 1px solid #D5D8DE;
		border-radius: 4px;
	}
</style>
